import { Injectable } from '@angular/core';
import { AbstractResourceService, JsonApiListResourceMetadataBase, JsonApiResource } from '@irian-ro/abstract-resource';
import {
  BlacklistItemValidityDtoModel,
  CustomerBlacklistItemDtoModel
} from '@well/domain';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '@irian-ro/util-environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomerBlacklistItemResourceService extends AbstractResourceService<never,
  CustomerBlacklistItemDtoModel,
  never,
  never> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('customerBlacklistItemUrl'),
      undefined,
      undefined
    );
  }

  getCustomerBlacklistHistory(customerUuid: string) : Observable<JsonApiResource<BlacklistItemValidityDtoModel[], JsonApiListResourceMetadataBase>> {
    return <Observable<JsonApiResource<BlacklistItemValidityDtoModel[], JsonApiListResourceMetadataBase>> >this.httpClient?.get(`${this.url}/validity/history/${customerUuid}`);
  }
}
